"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { drawerVariants } from "./Drawer.variants.js";
const { title: title } = drawerVariants();
const DrawerTitle_DrawerTitle = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    return /*#__PURE__*/ jsx(Drawer.Title, {
        ref: ref,
        className: cn(title(), className, slots?.title),
        ...props
    });
});
export { DrawerTitle_DrawerTitle as DrawerTitle };
